<template>
  <div class="import-modal-wrapper">
    <transition-group name="el-fade-in-linear">
      <div v-show="visibleType === 'import'" class="container" key="import">
        <ImportResume
          :displayAvatar="false"
          :displayBackBtn="false"
          @beforeCreateResume="beforeCreateResume"
          @nextStep="nextStep"
          @resumeChange="onSuccess"
          @prevStep="prevStep"
        />
      </div>
      <div v-show="visibleType === 'progress'" class="container" key="progress">
        <Progress
          :displayAvatar="false"
          :percentage="percentage"
          :fileImage="fileImage"
          :fileName="fileName"
        />
      </div>
    </transition-group>
    <transition name="el-fade-in-linear">
      <div v-if="!!visibleType" class="mask" @click="close"></div>
    </transition>
  </div>
</template>
<script>
import ImportResume from '@/views/ai/components/ImportResume.vue';
import Progress from '@/views/ai/components/Progress.vue';
import { resumeMixin } from '@/views/ai/resume.mixin';
import { routerTo } from '@/assets/js/util';
export default {
  name: 'ImportResumeModal',
  mixins: [resumeMixin],
  components: {
    ImportResume,
    Progress,
  },
  props: {
    visibleType: {
      type: String,
      default: 'import',
    },
  },
  methods: {
    nextStep() {
      this.$emit('next');
    },
    close() {
      if (this.visibleType === 'progress') return;
      this.$emit('close');
    },
    onSuccess(token) {
      this.resumeChange(token);
      const timer = setTimeout(() => {
        routerTo(`/cvs/${token}/editor`);
        clearTimeout(timer);
      }, 500);
    },
    prevStep() {
      this.$emit('prev')
    }
  },
};
</script>
<style lang="scss" scoped>
.import-modal-wrapper {
  .container {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 101;
    width: fit-content;
    :deep(.onboarding-block-container) {
      margin-top: 0;
      border-radius: 12px;
    }
  }
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
</style>
